import {config} from '@config';

import {ConnectedComponent} from '@lib/ConnectedComponent';
import {appSelectors} from '@lib/store/appState';
import {MediaQuery} from '@services/MediaQuery';

export class Kv extends ConnectedComponent {
  private mq = MediaQuery.create();

  didMount() {
    this.observe(appSelectors.selectOrientation, async () => {
      this.onChangeOrientation();
    });
    this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
      if (status === 'endHideAnimation') {
        this.element?.classList.add('viewed');
      }
    });

    if (this.mq.isPhone()) {
      this.onChangeOrientation();
    }
  }

  onChangeOrientation() {
    const height = window.innerHeight;
    const headerHeight = this.mq.isPhone() ? config.headerHeight : 0;
    if (this.element) {
      this.element.style.height = `${height - headerHeight}px`;
    }
  }
}
